import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bemGenerator } from '@prisjakt/ui-base';
import campaignColor from '../../globals/helpers/campaign/get-campaign-color';
import { trackCampaignLinkClick } from '../../areas/campaign/tracking';

import './index.scss';

const styles = bemGenerator('campaign-label', ['title', 'icon']);

const icon = color => (
  <svg width="15" height="13" viewBox="0 0 15 13">
    <path
      d="M3.5 3.3c0-.555-.445-1-1-1-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1zm8.336 4.5c0 .266-.11.523-.29.703l-3.835 3.844c-.187.18-.444.29-.71.29-.266 0-.523-.11-.703-.29L.71 6.753C.314 6.363 0 5.605 0 5.05V1.8c0-.547.453-1 1-1h3.25c.555 0 1.313.312 1.71.71l5.587 5.58c.18.187.29.444.29.71zm3 0c0 .266-.11.523-.29.703l-3.835 3.844c-.187.18-.444.29-.71.29-.406 0-.61-.19-.875-.462l3.672-3.672c.18-.18.29-.437.29-.703 0-.266-.11-.523-.29-.71L7.21 1.51C6.814 1.113 6.056.8 5.5.8h1.75c.555 0 1.313.312 1.71.71l5.587 5.58c.18.187.29.444.29.71z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

const CampaignLabel = ({
  className,
  campaignId,
  title,
  showIcon,
  showTitle,
  link,
}) => {
  const bgColor = campaignColor(campaignId, 'background');
  const textColor = campaignColor(campaignId, 'text');
  const trackClick = useCallback(() => {
    trackCampaignLinkClick(campaignId, 'campaign_label');
  }, [campaignId]);

  if (!bgColor || !textColor) {
    return null;
  }

  const label = (
    <span
      style={{ backgroundColor: bgColor }}
      title={title}
      className={styles.block.withModifier({
        'with-title': showTitle,
        'only-icon': !showTitle && showIcon,
      })}
    >
      {showIcon && icon(textColor)}
      {showTitle && (
        <span className={styles.title} style={{ color: textColor }}>
          {title}
        </span>
      )}
    </span>
  );

  return link ? (
    <Link to={link} className={className} onClick={trackClick}>
      {label}
    </Link>
  ) : (
    label
  );
};

const { string, number, bool, oneOfType } = PropTypes;
CampaignLabel.propTypes = {
  className: string,
  campaignId: oneOfType([string, number]).isRequired,
  title: string.isRequired,
  showIcon: bool,
  showTitle: bool,
  link: string,
};

CampaignLabel.defaultProps = {
  className: undefined,
  showIcon: true,
  showTitle: true,
  link: undefined,
};

export default CampaignLabel;
